// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pickup-choice-block .choice-buttons {
  display: flex;
  gap: 8px;
  margin: 2px 0;
}
.pickup-choice-block .choice-buttons ion-button {
  flex: 1;
  margin: 0;
  height: 36px;
}
.pickup-choice-block .choice-buttons .theme-btn,
.pickup-choice-block .choice-buttons .theme-btn-alt {
  font-size: 0.7222222222rem;
  --padding-top: 0;
  --padding-bottom: 0;
}
.pickup-choice-block .choice-buttons .theme-btn {
  background: #E82973;
  --background: #E82973;
}
.pickup-choice-block .choice-buttons .theme-btn::part(native) {
  background: #E82973 !important;
}
.pickup-choice-block .locked-card {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #F7F7F8;
  border: 0.5px solid #ECECEC;
  border-radius: 14px;
  padding: 10px 14px;
  margin-top: 2px;
}
.pickup-choice-block .locked-card ion-icon {
  font-size: 15px;
  color: #777777;
  margin-top: 2px;
}
.pickup-choice-block .locked-card span {
  font-size: 0.6666666667rem;
  color: #777777;
  line-height: 1.4;
}
.pickup-choice-block .waiting-text {
  display: block;
  font-size: 0.6111111111rem;
  color: #777777;
  margin-top: 4px;
}
.pickup-choice-block .errorMessage {
  display: block;
  font-size: 0.6666666667rem;
  color: var(--ion-color-danger);
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pickup-choice-item/pickup-choice-item.component.scss"],"names":[],"mappings":"AAEI;EACI,aAAA;EACA,QAAA;EACA,aAAA;AADR;AAGQ;EACI,OAAA;EACA,SAAA;EACA,YAAA;AADZ;AAIQ;;EAEI,0BAAA;EACA,gBAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,mBAAA;EACA,qBAAA;AAHZ;AAKY;EACI,8BAAA;AAHhB;AAQI;EACI,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AANR;AAQQ;EACI,eAAA;EACA,cAAA;EACA,eAAA;AANZ;AASQ;EACI,0BAAA;EACA,cAAA;EACA,gBAAA;AAPZ;AAWI;EACI,cAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;AATR;AAYI;EACI,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,eAAA;AAVR","sourcesContent":["@use \"../../../theme/mixins.scss\" as *;\n.pickup-choice-block {\n    .choice-buttons {\n        display: flex;\n        gap: 8px;\n        margin: 2px 0;\n\n        ion-button {\n            flex: 1;\n            margin: 0;\n            height: 36px;\n        }\n\n        .theme-btn,\n        .theme-btn-alt {\n            font-size: calculateRem(13px);\n            --padding-top: 0;\n            --padding-bottom: 0;\n        }\n\n        .theme-btn {\n            background: #E82973;\n            --background: #E82973;\n\n            &::part(native) {\n                background: #E82973 !important;\n            }\n        }\n    }\n\n    .locked-card {\n        display: flex;\n        align-items: flex-start;\n        gap: 8px;\n        background: #F7F7F8;\n        border: 0.5px solid #ECECEC;\n        border-radius: 14px;\n        padding: 10px 14px;\n        margin-top: 2px;\n\n        ion-icon {\n            font-size: 15px;\n            color: #777777;\n            margin-top: 2px;\n        }\n\n        span {\n            font-size: calculateRem(12px);\n            color: #777777;\n            line-height: 1.4;\n        }\n    }\n\n    .waiting-text {\n        display: block;\n        font-size: calculateRem(11px);\n        color: #777777;\n        margin-top: 4px;\n    }\n\n    .errorMessage {\n        display: block;\n        font-size: calculateRem(12px);\n        color: var(--ion-color-danger);\n        margin-top: 4px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
